import React, { useState } from 'react';
import './SupportPages.css';

interface FAQItem {
  question: string;
  answer: string;
  category: string;
}

const FAQ: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState<string>('all');
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const categories = [
    { id: 'all', name: '전체' },
    { id: 'service', name: '서비스 이용' },
    { id: 'payment', name: '요금/결제' },
    { id: 'technical', name: '기술지원' },
    { id: 'account', name: '계정관리' }
  ];

  const faqData: FAQItem[] = [
    {
      category: 'service',
      question: 'TTS 자동 전화 발신은 어떻게 이용하나요?',
      answer: '로그인 후 "TTS 전화" 메뉴에서 발신할 전화번호와 음성으로 변환할 메시지를 입력하고 발신 버튼을 클릭하면 됩니다. 엑셀 파일로 대량 발신도 가능합니다.'
    },
    {
      category: 'service',
      question: '한 번에 몇 건까지 발신할 수 있나요?',
      answer: '한 번에 최대 10,000건까지 발신 가능합니다. 그 이상의 대량 발신이 필요한 경우 고객센터로 문의해주세요.'
    },
    {
      category: 'service',
      question: '발신 실패한 경우는 어떻게 되나요?',
      answer: '발신 실패 시 크레딧은 차감되지 않습니다. 자동 재발신 기능을 설정하면 실패한 건에 대해 자동으로 재발신을 시도합니다.'
    },
    {
      category: 'service',
      question: 'DTMF 설문조사는 무엇인가요?',
      answer: 'DTMF는 전화기 버튼을 누를 때 발생하는 신호입니다. 전화를 받은 사람이 버튼(0-9, *, #)을 눌러 응답할 수 있는 설문조사 기능입니다.'
    },
    {
      category: 'payment',
      question: '요금은 어떻게 청구되나요?',
      answer: '선불 충전 방식으로, 크레딧을 미리 충전한 후 사용하는 만큼 차감됩니다. 기본 요금은 1회 발신당 30원입니다.'
    },
    {
      category: 'payment',
      question: '크레딧 충전 방법은 무엇인가요?',
      answer: '마이페이지에서 신용카드, 계좌이체, 무통장입금 등의 방법으로 충전할 수 있습니다. 충전 금액에 따라 보너스 크레딧이 제공됩니다.'
    },
    {
      category: 'payment',
      question: '크레딧 환불이 가능한가요?',
      answer: '충전 후 7일 이내, 미사용 크레딧에 한해 환불 가능합니다. 단, 결제 수수료를 제외한 금액이 환불됩니다.'
    },
    {
      category: 'payment',
      question: '크레딧 유효기간이 있나요?',
      answer: '충전일로부터 1년간 유효합니다. 유효기간 내에 재충전 시 전체 크레딧의 유효기간이 재충전일로부터 1년으로 연장됩니다.'
    },
    {
      category: 'technical',
      question: '엑셀 파일 업로드 시 양식이 있나요?',
      answer: '네, 서비스 페이지에서 엑셀 양식을 다운로드할 수 있습니다. 전화번호, 메시지 등 필수 항목이 포함되어 있습니다.'
    },
    {
      category: 'technical',
      question: '발신 시간을 예약할 수 있나요?',
      answer: '네, 발신 설정에서 원하는 날짜와 시간을 지정하여 예약 발신이 가능합니다.'
    },
    {
      category: 'technical',
      question: '발신 결과를 확인할 수 있나요?',
      answer: '대시보드에서 실시간으로 발신 현황을 확인할 수 있으며, 발신 이력 페이지에서 상세한 결과를 엑셀로 다운로드할 수 있습니다.'
    },
    {
      category: 'technical',
      question: '음성 속도나 톤을 조절할 수 있나요?',
      answer: '현재는 표준 음성으로 제공되며, 향후 업데이트를 통해 음성 옵션이 추가될 예정입니다.'
    },
    {
      category: 'account',
      question: '비밀번호를 잊어버렸어요.',
      answer: '로그인 페이지에서 "비밀번호 찾기"를 클릭하여 등록된 이메일로 비밀번호 재설정 링크를 받을 수 있습니다.'
    },
    {
      category: 'account',
      question: '회원 탈퇴는 어떻게 하나요?',
      answer: '마이페이지 > 계정 설정에서 회원 탈퇴를 신청할 수 있습니다. 탈퇴 시 잔여 크레딧은 자동 환불되지 않으니 유의해주세요.'
    },
    {
      category: 'account',
      question: '이메일 주소를 변경할 수 있나요?',
      answer: '보안상의 이유로 이메일 주소는 직접 변경이 불가능합니다. 고객센터로 문의해주시면 본인 확인 후 변경해드립니다.'
    }
  ];

  const filteredFAQs = activeCategory === 'all'
    ? faqData
    : faqData.filter(faq => faq.category === activeCategory);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="support-page">
      <div className="container">
        <div className="support-header">
          <h1 className="section-title">자주 묻는 질문</h1>
          <p className="section-subtitle">
            궁금하신 내용을 빠르게 찾아보세요
          </p>
        </div>

        <div className="faq-categories">
          {categories.map(category => (
            <button
              key={category.id}
              className={`category-btn ${activeCategory === category.id ? 'active' : ''}`}
              onClick={() => setActiveCategory(category.id)}
            >
              {category.name}
            </button>
          ))}
        </div>

        <div className="faq-list">
          {filteredFAQs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? 'open' : ''}`}
            >
              <button
                className="faq-question"
                onClick={() => toggleFAQ(index)}
              >
                <span className="question-icon">Q</span>
                <span className="question-text">{faq.question}</span>
                <span className="toggle-icon">{openIndex === index ? '−' : '+'}</span>
              </button>
              {openIndex === index && (
                <div className="faq-answer">
                  <span className="answer-icon">A</span>
                  <p className="answer-text">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="support-footer">
          <p>찾으시는 답변이 없으신가요?</p>
          <a href="/contact" className="btn btn-primary">문의하기</a>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
